export const KPI_PARAM_NAME = 'kpiTagname'
